import React from 'react';

import {ProteinAnnotationsPanelState} from 'FileStates';
import Protein from 'molbio/aa-sequences/AaSequence';
import ProteinAnnotationsPanel from 'toolbar/aa-sequence/AaSequenceAnnotationsPanel';
import ReactPanelBaseView, {getTabAndPanelIds, Subpanel} from 'toolbar/ReactPanelBaseView';

class ProteinAnnotationsPanelView extends ReactPanelBaseView<ProteinAnnotationsPanelState, Protein> {
  _jumpToSelection = (start: number, end: number): void => {
    this.model.selection().triggerJump(start, end);
  };

  getSubpanels(): Array<Subpanel> {
    return [
      {
        ...getTabAndPanelIds('proteinAnnotations'),
        title: 'Annotations',
        component: (
          <ProteinAnnotationsPanel proteinId={this.model.id} jumpToSelection={this._jumpToSelection} />
        ),
      },
    ];
  }
}

export default ProteinAnnotationsPanelView;
